import Article from "./Article";


const ArticlesContainer = ({quotes, auteur}) => {

    return (
        <Article
            key={quotes.id}
            content={quotes.content}
            auteur={auteur}
        />
    );
};

export default ArticlesContainer;